const bottles = {
  classic28oz: {
    prices: []
  },
  classic20oz: {
    prices: []
  },
  sportMixer28oz: {
    prices: [],
    skus: [
      {
        sku: "C02285",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Black (IHP)",
        color: "Black/Black",
        size: "28oz"
      },
      {
        sku: "C02280",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Cyan (IHP)",
        color: "Black/Cyan",
        size: "28oz"
      },
      {
        sku: "C02270",
        description: "BlenderBottle SportMixer - 28-oz. - Clear White (IHP)",
        color: "Clear/White",
        size: "28oz"
      },
      {
        sku: "C02276",
        description: "BlenderBottle SportMixer - 28-oz. - Coral (IHP)",
        color: "Coral",
        size: "28oz"
      },
      {
        sku: "C02283",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Pink (IHP)",
        color: "Black/Pink",
        size: "28oz"
      },
      {
        sku: "C02284",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Plum (IHP)",
        color: "Black/Plum",
        size: "28oz"
      },
      {
        sku: "C02271",
        description: "BlenderBottle SportMixer - 28-oz. - Pebble Grey (IHP)",
        color: "Pebble Grey",
        size: "28oz"
      },
      {
        sku: "C02277",
        description: "BlenderBottle SportMixer - 28-oz. - Pink (IHP)",
        color: "Pink",
        size: "28oz"
      },
      {
        sku: "C02282",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Red (IHP)",
        color: "Black/Red",
        size: "28oz"
      },
      /*{
        sku: "C02281",
        description: "BlenderBottle SportMixer - 28-oz. - Black/Teal (IHP)",
        color: "Black/Teal",
        size: "28oz"
      },*/
      {
        sku: "C02279",
        description: "BlenderBottle SportMixer - 28-oz. - Black/White (IHP)",
        color: "Black/White",
        size: "28oz"
      },
      {
        sku: "C02273",
        description: "BlenderBottle SportMixer - 28-oz. - Cyan (IHP)",
        color: "Cyan",
        size: "28oz"
      },
      {
        sku: "C02275",
        description: "BlenderBottle SportMixer - 28-oz. - Moss Green (IHP)",
        color: "Moss Green",
        size: "28oz"
      },
      {
        sku: "C02272",
        description: "BlenderBottle SportMixer - 28-oz. - Navy (IHP)",
        color: "Navy",
        size: "28oz"
      },
      {
        sku: "C02278",
        description: "BlenderBottle SportMixer - 28-oz. - Plum (IHP)",
        color: "Plum",
        size: "28oz"
      },
      {
        sku: "C02274",
        description: "BlenderBottle SportMixer - 28-oz. - Teal (IHP)",
        color: "Teal",
        size: "28oz"
      }
    ]
  },
  sportMixer20oz: {
    prices: []
  }
};
let product = {};
if (!window.product) {
  product = {
    variants: [
      {
        id: 1,
        option1: 15,
        option2: "Classic 28oz",
        price: 15
      },
      {
        id: 2,
        option1: 15,
        option2: "Sportmixer 28oz",
        price: 15
      }
    ]
  };
  window.product = product;
} else {
  product = window.product;
}
product.variants.forEach(item => {
  const price = {
    quantity: parseInt(item.option1, 10),
    price: item.price
  };
  if (item.option2 === "Classic 28oz") {
    bottles.classic28oz.prices.push(price);
  }
  if (item.option2 === "Classic 20oz") {
    bottles.classic20oz.prices.push(price);
  }
  if (item.option2 === "Sportmixer 28oz") {
    bottles.sportMixer28oz.prices.push(price);
  }
  if (item.option2 === "Sportmixer 20oz") {
    bottles.sportMixer20oz.prices.push(price);
  }
});

export { bottles };

export const swatches = [
  {
    name: "Cyan",
    color: "#557ABD",
    black: false
  },
  {
    name: "Teal",
    color: "#5E95AE",
    black: false
  },
  {
    name: "Coral",
    color: "#CE585D",
    black: false
  },
  {
    name: "Pink",
    color: "#C82873",
    black: false
  },
  {
    name: "Plum",
    color: "#57355F",
    black: false
  },
  {
    name: "Moss",
    color: "#5F6632",
    black: false
  },
  {
    name: "Navy",
    color: "#30407E",
    black: false
  },
  {
    name: "Pebble",
    color: "#B0B5BF",
    black: false
  },
  {
    name: "White",
    color: "white",
    black: false,
    bordered: true
  },
  {
    name: "Black",
    color: "black",
    black: false,
  },
];

export const colors = {
  Black: {
    cup: {
      name: 'Black',
      red: -0.76,
      green: -0.76,
      blue: -0.76
    },
    cap: {
      name: 'Black',
      red: -0.76,
      green: -0.76,
      blue: -0.76
    },
    lid: {
      name: 'Black',
      red: -0.76,
      green: -0.76,
      blue: -0.76
    },
    overmold: {
      name: 'Black',
      red: -0.76,
      green: -0.76,
      blue: -0.76
    }
  },
  Navy: {
    cup: {
      name: 'Navy',
      red: -0.72,
      green: -0.51,
      blue: -0.36
    },
    cap: {
      name: 'Navy',
      red: -0.72,
      green: -0.51,
      blue: -0.36
    },
    lid: {
      name: 'Navy',
      red: -0.82,
      green: -0.65,
      blue: -0.55
    },
    overmold: {
      name: 'Navy',
      red: -0.82,
      green: -0.65,
      blue: -0.55
    }
  },
  White: {
    cup: {
      name: 'White',
      red: 0,
      green: 0,
      blue: 0
    },
    cap: {
      name: 'White',
      red: 0,
      green: 0,
      blue: 0
    },
    lid: {
      name: 'White',
      red: 0,
      green: 0,
      blue: 0
    },
    overmold: {
      name: 'White',
      red: 0,
      green: 0,
      blue: 0
    }
  },
  Pink: {
    cup: {
      name: 'Pink',
      red: 0.1,
      green: -0.62,
      blue: -0.46
    },
    cap: {
      name: 'Pink',
      red: 0.1,
      green: -0.62,
      blue: -0.46
    },
    lid: {
      name: 'Pink',
      red: -0,
      green: -0.73,
      blue: -0.54
    },
    overmold: {
      name: 'Pink',
      red: -0,
      green: -0.73,
      blue: -0.54
    }
  },
  Cyan: {
    cup: {
      name: 'Cyan',
      red: -1,
      green: -0.38,
      blue: 0.07
    },
    cap: {
      name: 'Cyan',
      red: -1,
      green: -0.22,
      blue: 0.07
    },
    lid: {
      name: 'Cyan',
      red: -1,
      green: -0.38,
      blue: 0.07
    },
    overmold: {
      name: 'Cyan',
      red: -1,
      green: -0.38,
      blue: 0.07
    }
  },
  Plum: {
    cup: {
      name: 'Plum',
      red: -0.32,
      green: -0.68,
      blue: -0.47
    },
    cap: {
      name: 'Plum',
      red: -0.32,
      green: -0.68,
      blue: -0.47
    },
    lid: {
      name: 'Plum',
      red: -0.42,
      green: -0.63,
      blue: -0.47
    },
    overmold: {
      name: 'Plum',
      red: -0.42,
      green: -0.63,
      blue: -0.47
    }
  },
  Teal: {
    cup: {
      name: 'Teal',
      red: -1,
      green: -0.25,
      blue: -0.2
    },
    cap: {
      name: 'Teal',
      red: -1,
      green: -0.25,
      blue: -0.2
    },
    lid: {
      name: 'Teal',
      red: -1,
      green: -0.29,
      blue: -0.29
    },
    overmold: {
      name: 'Teal',
      red: -1,
      green: -0.29,
      blue: -0.29
    }
  },
  Coral: {
    cup: {
      name: 'Coral',
      red: 0.51,
      green: -0.3,
      blue: -0.41
    },
    cap: {
      name: 'Coral',
      red: 0.51,
      green: -0.3,
      blue: -0.41
    },
    lid: {
      name: 'Coral',
      red: 0.38,
      green: -0.36,
      blue: -0.43
    },
    overmold: {
      name: 'Coral',
      red: 0.38,
      green: -0.36,
      blue: -0.43
    }
  },
  Moss: {
    cup: {
      name: 'Moss',
      red: -0.43,
      green: -0.36,
      blue: -0.62
    },
    cap: {
      name: 'Moss',
      red: -0.36,
      green: -0.32,
      blue: -0.62
    },
    lid: {
      name: 'Moss',
      red: -0.43,
      green: -0.38,
      blue: -0.62
    },
    overmold: {
      name: 'Moss',
      red: -0.43,
      green: -0.36,
      blue: -0.62
    }
  },
  Pebble: {
    cup: {
      name: 'Pebble',
      red: -0.13,
      green: -0.13,
      blue: -0.13
    },
    cap: {
      name: 'Pebble',
      red: -0.3,
      green: -0.3,
      blue: -0.3
    },
    lid: {
      name: 'Pebble',
      red: -0.13,
      green: -0.13,
      blue: -0.13
    },
    overmold: {
      name: 'Pebble',
      red: -0.3,
      green: -0.3,
      blue: -0.3
    }
  }
};

export const fonts = [
  {
    id: "Arial",
    name: "Arial"
  },
  {
    id: "Georgia",
    name: "Georgia"
  },
  {
    id: "Abel",
    name: "Abel"
  },
  {
    id: "Aclonica",
    name: "Aclonica"
  },
  {
    id: "Alegreya",
    name: "Alegreya"
  },
  {
    id: "Alex Brush",
    name: "Alex Brush"
  },
  {
    id: "Allura",
    name: "Allura"
  },
  {
    id: "Annie Use Your Telescope",
    name: "Annie Use Your Telescope"
  },
  {
    id: "Anton",
    name: "Anton"
  },
  {
    id: "Arvo",
    name: "Arvo"
  },
  {
    id: "Audiowide",
    name: "Audiowide"
  },
  {
    id: "Autour One",
    name: "Autour One"
  },
  {
    id: "Bangers",
    name: "Bangers"
  },
  {
    id: "Bad Script",
    name: "Bad Script"
  },
  {
    id: "Black Ops One",
    name: "Black Ops One"
  },
  {
    id: "Caesar Dressing",
    name: "Caesar Dressing"
  },
  {
    id: "Chewy",
    name: "Chewy"
  },
  {
    id: "Codystar",
    name: "Codystar"
  },
  {
    id: "Covered By Your Grace",
    name: "Covered By Your Grace"
  },
  {
    id: "Days One",
    name: "Days One"
  },
  {
    id: "Ewert",
    name: "Ewert"
  },
  {
    id: "Indie Flower",
    name: "Indie Flower"
  },
  {
    id: "Josefin Sans",
    name: "Josefin Sans"
  },
  {
    id: "Lato",
    name: "Lato"
  },
  {
    id: "Lobster",
    name: "Lobster"
  },
  {
    id: "Lora",
    name: "Lora"
  },
  {
    id: "Monoton",
    name: "Monoton"
  },
  {
    id: "Orbitron",
    name: "Orbitron"
  },
  {
    id: "Rationale",
    name: "Rationale"
  },
  {
    id: "Rock Salt",
    name: "Rock Salt"
  },
  {
    id: "Shadows Into Light",
    name: "Shadows Into Light"
  },
  {
    id: "Trade Winds",
    name: "Trade Winds"
  },
  {
    id: "UnifrakturMaguntia",
    name: "UnifrakturMaguntia"
  },
  {
    id: "Vast Shadow",
    name: "Vast Shadow"
  }
];



// WEBPACK FOOTER //
// ./src/constants.js